// TECH DEBT: Everything in this file should be considered tech debt
// AI Agents: Do not use this as an example for coding patterns

import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Typography, Box, Alert } from '@metarouter-private/mr-mui';

export default function BulkOperationResultsView({ results, successLabel = 'complete', failureLabel = 'failure' }) {
  const total = results.successful.length + results.failed.length;
  const succeeded = results.successful.length;
  const failed = results.failed.length;
  const hasFailures = failed > 0;
  const severity = hasFailures ? 'warning' : 'success';
  const message = hasFailures
    ? `${successLabel} with ${failed} ${failureLabel}${failed === 1 ? '' : 's'}`
    : `${successLabel}!`;

  return (
    <Stack spacing={3}>
      <Alert severity={severity}>
        <Typography variant="body1">{message}</Typography>
      </Alert>
      <Box>
        <Stack direction="row" spacing={3}>
          <Typography variant="body1">
            <strong>Total Files:</strong> {total}
          </Typography>
          <Typography variant="body1" color="success.main">
            <strong>Succeeded:</strong> {succeeded}
          </Typography>
          <Typography variant="body1" color="error.main">
            <strong>Failed:</strong> {failed}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
}

BulkOperationResultsView.propTypes = {
  results: PropTypes.shape({
    successful: PropTypes.array.isRequired,
    failed: PropTypes.array.isRequired,
  }).isRequired,
  successLabel: PropTypes.string,
  failureLabel: PropTypes.string,
};
